module.exports = function (globalHeaderPanelService) {
    return {
        restrict: 'E',
        template: require('./signup-panel-template.html').trim(),
        scope: {},
        link(scope) {
            scope.isOpen = function () {
                return globalHeaderPanelService.isOpen(globalHeaderPanelService.panels.signup);
            };

            scope.toggle = function () {
                return globalHeaderPanelService.togglePanel(globalHeaderPanelService.panels.signup);
            };
        }
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/signup/signup-panel-directive.js
 **/